/**
 * Aktuelle App-Version, ohne das Update-Log zu laden — `changelog.ts` ist groß und
 * gehört nicht ins Start-Bundle. Der Wert kommt beim Bauen aus dem obersten Eintrag.
 */
export const APP_VERSION: string = __APP_VERSION__;
